var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.0201 3.48004C17.0801 1.54004 15.1801 1.49004 13.1901 3.48004L11.9801 4.69004C11.8801 4.79004 11.8401 4.95004 11.8801 5.09004C12.6401 7.74004 14.7601 9.86003 17.4101 10.62C17.4501 10.63 17.4901 10.64 17.5301 10.64C17.6401 10.64 17.7401 10.6 17.8201 10.52L19.0201 9.31004C20.0101 8.33004 20.4901 7.38004 20.4901 6.42004C20.5001 5.43004 20.0201 4.47004 19.0201 3.48004Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.6098 11.53C15.3198 11.39 15.0398 11.25 14.7698 11.09C14.5498 10.96 14.3398 10.82 14.1298 10.67C13.9598 10.56 13.7598 10.4 13.5698 10.24C13.5498 10.23 13.4798 10.17 13.3998 10.09C13.0698 9.81005 12.6998 9.45005 12.3698 9.05005C12.3398 9.03005 12.2898 8.96005 12.2198 8.87005C12.1198 8.75005 11.9498 8.55005 11.7998 8.32005C11.6798 8.17005 11.5398 7.95005 11.4098 7.73005C11.2498 7.46005 11.1098 7.19005 10.9698 6.91005C10.9486 6.86465 10.9281 6.81949 10.9083 6.77458C10.7607 6.44127 10.3261 6.34382 10.0683 6.60158L4.33983 12.33C4.20983 12.46 4.08983 12.71 4.05983 12.88L3.51983 16.71C3.41983 17.39 3.60983 18.03 4.02983 18.46C4.38983 18.81 4.88983 19 5.42983 19C5.54983 19 5.66983 18.99 5.78983 18.97L9.62983 18.43C9.80983 18.4 10.0598 18.28 10.1798 18.15L15.9011 12.4287C16.1607 12.1692 16.0628 11.7237 15.7252 11.5797C15.6872 11.5634 15.6488 11.5469 15.6098 11.53Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.cb4dfbc33ec88f2406f94874f9549133.svg";
export { ForwardRef as ReactComponent };